import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { announceWorkspaceChange } from "../data/usePolledResource";
import { BackIcon } from "../components/Icons";
import LearnerWork from "../components/LearnerWork";
import ui from "../components/ui.module.css";

// The existing Handoff 004 work-and-review view, reached from Work or a
// learner. Marking it reviewed returns to where the teacher came from.
const WorkReview = () => {
  const { attemptId } = useParams();
  const navigate = useNavigate();
  const from = useLocation().state?.from || "/work";

  return (
    <div className={ui.page}>
      <Link to={from} className={ui.textButton}>
        <BackIcon />
        {from === "/work" ? "Work to review" : "Back"}
      </Link>
      <h1 className={ui.title}>Review work</h1>
      <LearnerWork
        key={attemptId}
        attemptId={attemptId}
        onSaved={announceWorkspaceChange}
        onDone={() => navigate(from)}
      />
    </div>
  );
};

export default WorkReview;
